import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogContent, DialogTitle, Typography, styled } from 'netline-ui';

import { useAboutModules } from '../../../Navigation';

import ContentType from './consts';
import styles, { supportContentClasses } from './SupportContent.styles';

const SupportContentRoot = styled('div', { name: supportContentClasses.$name })(styles);

type SupportContentProps = {
  onContentChange: (contentType: ContentType | null) => void;
};

const SupportContent = ({ onContentChange }: SupportContentProps) => {
  const { t } = useTranslation();

  const { activeModule } = useAboutModules(null);
  const { contactInfo } = activeModule ?? {};
  const { phone, email } = contactInfo ?? {};

  const handleCloseClick = useCallback(() => onContentChange(null), [onContentChange]);
  const handleBackButtonClick = useCallback(() => onContentChange(ContentType.GENERAL), [onContentChange]);

  return (
    <SupportContentRoot className={supportContentClasses.root}>
      <DialogTitle disableTypography variant="h3" onClose={handleCloseClick} onBack={handleBackButtonClick}>
        <Typography variant="h3" component="span" className={supportContentClasses.titleText}>
          {t('about.support_title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {phone ?? (
          <div>
            {t('about.phone')}
            <a href={`tel:${phone}`} className={supportContentClasses.contactValue}>
              {phone}
            </a>
          </div>
        )}
        {email && (
          <div>
            {t('about.email')}
            <a href={`mailto:${email}`} className={supportContentClasses.contactValue}>
              {email}
            </a>
          </div>
        )}
      </DialogContent>
    </SupportContentRoot>
  );
};

export default SupportContent;
